import React, { createContext } from 'react';

interface ITranslatingContainerProvider {
  children: React.ReactNode;
}

interface ITranslatingContainerContext {
  sliderIndex: number;
  setSliderIndexPos: (value: number) => void;
  resetSliderIndex: () => void;
}

export const TranslatingContainerContext =
  createContext<ITranslatingContainerContext | null>(null);

const TranslatingContainerProvider: React.FC<ITranslatingContainerProvider> = ({
  children,
}) => {
  const [sliderIndex, setSliderIndex] = React.useState(0);

  return (
    <TranslatingContainerContext.Provider
      value={{
        sliderIndex,
        setSliderIndexPos: (value: number) =>
          setSliderIndex((prev) => prev + value),
        resetSliderIndex: () => setSliderIndex(0),
      }}
    >
      {children}
    </TranslatingContainerContext.Provider>
  );
};

export default TranslatingContainerProvider;
